module.exports = __webpack_public_path__ + "img/cbxkz.9bdc2520.jpg";